import React, { useEffect } from 'react';
import {makeStyles} from "@material-ui/core/styles/index";
import Typography from "@material-ui/core/es/Typography/Typography";
import Grid from "@material-ui/core/Grid/Grid";
import * as ReactGA from "react-ga";
import SupportRequest from "./SupportRequest";

const useStyles = makeStyles((theme) => {
    return {
        root: {
            position: 'relative',
            width: '100%',
            marginBottom: 10,
            marginTop: 10,
        },
        header: {
            position: 'relative',
            backgroundColor: '#3f51b4',
            padding: 10,
            '& p': {
                color: '#fff',
                display: 'inline'
            },
        },
        status: {
            position: 'absolute',
            right: 20,
            top: 12,
            '& div': {
                border: '1px solid #fff',
                height: 8,
                width: 8,
                backgroundColor: 'lightgreen',
                borderRadius: '50%',
                display: 'inline-block',
            },
            '& p': {
                fontSize: '.9rem',
                marginLeft: 5
            }
        },
        operator: {
            position: 'relative',
            width: 83,
            ['@media (min-width:701px)']: {
                width: 280,
            },
            display: 'inline-block',
            '& img': {
                borderRadius: 4,
                ['@media (min-width:701px)']: {
                    borderRadius: 0,
                },
            },
        },
        messageBox: {
            marginLeft: 10,
            marginTop: 10,
            ['@media (min-width:701px)']: {
                marginLeft: 0,
                marginTop: 0,
            },
            backgroundColor: '#fff',
        },
        operatorMessageBox: {
            width: 'calc(100% - 25px)',
            marginLeft: 10,
            marginTop: 0,
            padding: '5px 10px',
            backgroundColor: '#fff',
            border: '1px solid #3f51b4',
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
            borderTopRightRadius: 8,
            ['@media (min-width:701px)']: {
                width: 258,
                marginLeft: 0,
            },
            '& p': {
                ['@media (min-width:701px)']: {
                    fontSize: '1rem',
                },
            },
        },
        operatorName: {
            display: 'inline',
        },
        operatorMessage: {
        },
        startChatBtn: {
            border: '1px solid #3f51b4',
            padding: '1px 0px 1px 0px',
            borderRadius: 4,
            height: 24,
            cursor: 'pointer',
            textAlign: 'center',
            marginRight: 10,
            ['@media (min-width:701px)']: {
                marginRight: 0,
            },
            backgroundColor: '#3f51b4',
            color: '#fff',
            marginTop: 4,

        }
    }
});

export default function Support(props) {

    const classes = useStyles();

    const [request, setRequest] = React.useState();

    const isMobile = props.isMobile;

    const item = props.item;

    const width = props.screenWidth;
    const zoom = Math.min(1, width/414);

    const handleClick = () => {
        if (!request) {
            setRequest(true);
            window['FB'].CustomerChat.showDialog();
            ReactGA.event({
                category: 'User',
                action: 'chat_' + (props.item ? props.item.sn : 'other'),
                label: window.location.pathname
            });
        }
    }

    const onError = e => {

    };

    const onData = d => {

    };

    return (
        <div className={classes.root} style={zoom !== 1 ? {zoom: zoom} : null}>
            {request ? <SupportRequest values={{path: window.location.pathname}} onError={onError} onData={onData}/> : null}
            <div className={classes.boxCont}>
                <div className={classes.header}>
                    <Typography>Chat with operator</Typography>

                    <div className={classes.status}>
                        <div className={classes.iconOnline}></div>
                        <Typography>online</Typography>
                    </div>
                </div>
                <div className={classes.messageBox}>
                    <Grid container>
                        <Grid item>
                            <div className={classes.operator}>
                                <img src="/i/assets/operator.jpg?2" width="100%" alt="Chat with operator" title="Chat with operator"/>
                            </div>
                        </Grid>
                        <Grid>
                            <div className={classes.operatorMessageBox}>
                                <Typography className={classes.operatorName}>Hi, I'm Kate</Typography>
                                <Typography className={classes.operatorMessage}>{props.text ? props.text : <>How can i help? Ask me anything.</>}</Typography>
                            </div>
                        </Grid>
                    </Grid>
                    <div className={classes.startChatBtn} onClick={handleClick}><Typography>Start Chat</Typography></div>
                </div>

            </div>
        </div>
    );
}
